import React, { useCallback, useEffect, useRef, useState } from "react";
import { withRouter, RouteComponentProps, useHistory } from "react-router";
import * as CONSTANT from "../../constants";
import Spinner from "../../components/Spinner/Spinner";
import { Tab, Container, Nav, Modal } from "react-bootstrap";
import ItemGrid from "../../components/ItemGrid/ItemGrid";
import styleClasses from "./menu.module.scss";
import { useParams } from "react-router-dom";
import NewFooter from "../../components/Footer/NewFooter";
import Parser from "html-react-parser";
import UserSelections from "../../components/UserSelections/UserSelections";
import useCategories from "../../react-query-hooks/useCategories";
import MenuFilters from "./menuFilter";
import useFavorites from "../../react-query-hooks/useFavorites";
import { useAuthState } from "../../context/UserAuthentication/context";
import useRemoveFavorite from "../../react-query-hooks/Favorites/useRemoveFavorite";
import useAddFavorites from "../../react-query-hooks/Favorites/useAddFavorite";
import ItemSearch from "../../components/ItemSearch/itemSearch";
import { useStoreLocation } from "../../context/StoreLocation";
import { useLocation } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import { useAppDispatch, useAppSelector } from "../../redux/store/store";
import { resetRedeemedOrderContex } from "../../redux/slices/itemSlice";
import useGetRewardCatalog from "../../react-query-hooks/useGetRewardCatalog";
import Try2Combo from "../try2/try2";
import useAddToOrder from "../../hooks/useAddToOrder";
import KidsCombo from "../kidsCombo";
import useGetCustomerPlacedOrders from "../../react-query-hooks/useGetCustomerPlacedOrders";
import _debounce from "lodash/debounce";
import useGetTags from "../../react-query-hooks/useGetTags";
import { filters as filterData } from "./menuFilter/filtersData";
import useTry2Combo from "../../react-query-hooks/useTry2Combo";
import useKidsCombo from "../../react-query-hooks/useKidsCombo";
import { scrollOnSize } from "../../components/utils";
import uniqBy from "lodash.uniqby";
import { getFilteredItems, getResetFilters } from "../../helpers/helperMethods";
import { flatten } from "../../helpers/customizedItem/customizedItem.helper";
import {
  clearCart,
  setShowCart,
  updateCartOrder,
} from "../../redux/slices/cartSlice";
import { IGetCartPayload } from "../../models/order.model";
import { getCart } from "../../react-query-hooks/Cart/useGetCartItems";
import { brazeLogCustomEventViewPage } from "../../helpers/brazeHelper";
import useCheckMobileScreen from "../../hooks/useCheckMobileScreen";
import _clonedeep from "lodash.clonedeep";
import { IAccountStatus } from "../../models/misc";
import useVerifyAccount from "../../hooks/useVerifyAccount";
import AccountStatusModal from "../account/AccountStatusModal";
import { Helmet } from "react-helmet";
import { getStructuredItemList } from "../../helpers/scripts/seoScript";
import QRScanner from "../../components/QrCodeScanner/QRScanner";
import useKioskLogin from "../../hooks/useKioskLogin";

interface RouteParams {
  selected_category?: string;
}
interface RouteState {
  size?: string;
  name?: string;
  free?: boolean;
  toClaimCategory?: boolean;
  reward_id?: number;
}

const MenuContainer: React.FC<RouteComponentProps> = ({ history, match }) => {
  const { authInfo } = useAuthState();
  const { locationInfo } = useStoreLocation();
  const { showKioskResponseModal, QRScannerModal } = useKioskLoginFlow();
  const authUserId =
    authInfo?.type !== CONSTANT.GUEST_USER ? authInfo?.userId : null;

  const {
    isLoading,
    isError,
    isSuccess,
    error,
    data = { data: [] },
  } = useGetRewardCatalog({
    token: authInfo.authentication_token,
    location_id: locationInfo.selectedStore?.id,
    customer_id: authInfo.userId,
    userType: authInfo.type,
  });
  const redeemedOrder = useAppSelector((state: any) => state.Items.item);
  const isItMobile = useCheckMobileScreen();
  const Cart = useAppSelector((state) => state.cart);
  const dispatch = useAppDispatch();

  const [routerState, setRouterState] = useState<RouteState>({});
  const location: any = useLocation();
  const { search, state } = location;
  const query = new URLSearchParams(search);
  const dbId = query.get("id");
  const showCustomization =
    (state as { showCustomization?: boolean })?.showCustomization ?? false;

  const [key, setKey] = useState("");
  const [SearchShow, setSearchShow] = useState(false);
  const [activeFilters, setactiveFilters] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filterShow, setfilterShow] = useState<boolean>(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [stickyClass, setStickyClass] = React.useState("remove-sticky");
  const [onScrollNavHide, setOnScrollNavHide] = useState(false);
  const [onScrollNavPrevPos, setOnScrollNavPrevPos] = useState(100);
  const [categoryMenuVisbility, setCategoryMenuVisbility] =
    React.useState<boolean>(true);
  const [itemDetails, setItemDetails] = React.useState<boolean>(true);
  const { addToOrder } = useAddToOrder();
  const {
    refetch: refetchGetCustomerPlacedOrders,
    data: { data: placedOrders = [] } = [],
  } = useGetCustomerPlacedOrders({ userId: authInfo?.userId, userType: authInfo?.type });
  const { selected_category } = useParams<RouteParams>();
  const searchTextRef = useRef("");
  const autoScrollDivRef = useRef<HTMLDivElement>(null);
  const location_id = locationInfo.selectedStore?.id;
  const {
    data: menus = [],
    isFetching,
    refetch: refetchMenu,
  } = useCategories(location_id, authInfo);

  const [titleTag, setTitleTag] = useState<string>("");
  const [showScrollBar, setShowScrollBar] = useState<boolean>(true);

  const [items, setItems] = useState([]);
  const { data: allTags, isFetching: tagsFetching } = useGetTags();
  const [tagFilters, setTagFilters] = useState([]);

  const try2Item = menus.find((menu) => menu?.is_try_2_combo);
  const kidsComboItem = menus.find((menu) => menu?.is_kids_combo);
  const {
    data: itemFromApi,
    isFetching: isFetchingCombo,
    refetch: refetchTry2Combo,
  } = useTry2Combo({
    location_id: locationInfo.selectedStore?.id,
    category_id: try2Item?.id ? try2Item?.id.toString() : "",
    item_id: try2Item?.items[0] ? try2Item?.items[0]?.id?.toString() : "",
    customer_id:
      authInfo?.type !== CONSTANT.GUEST_USER ? authInfo?.userId : null,
  });

  const {
    data: kidsComboData,
    isFetching: kidsComboLoading,
    refetch: refetchKidsCombo,
  } = useKidsCombo({
    location_id: locationInfo.selectedStore?.id,
    category_id: kidsComboItem?.id ? kidsComboItem?.id.toString() : "",
    item_id: kidsComboItem?.items[0]
      ? kidsComboItem?.items[0]?.id?.toString()
      : "",
  });

  const getCartItems = async () => {
    try {
      if (!authInfo.userId) return;
      const payload: IGetCartPayload = {
        location_id: location_id,
        customer_id: authInfo.userId,
      };

      if (Cart?.orderType) {
        payload.order_type =
          Cart?.orderType === CONSTANT.DELIVERY_ORDER_TYPE
            ? CONSTANT.DELIVERY_DESTINATION_ID
            : CONSTANT.IN_STORE_DESTINATION_ID;
      }
      const response = await getCart(payload);
      if (response && response.items) dispatch(updateCartOrder(response));
      else {
        dispatch(clearCart());
      }
      dispatch(setShowCart(location?.state?.shouldOpenCart));
    } catch (error) {
      // dispatch(resetCart())
    }
  };

  useEffect(() => {
    location?.state?.shouldOpenCart && getCartItems();
  }, []);

  useEffect(() => {
    if (locationInfo?.selectedStore?.id) {
      refetchMenu();
      if (kidsComboItem) refetchKidsCombo();
      if (try2Item) refetchTry2Combo();
    }
  }, [Cart.orderType, locationInfo?.selectedStore?.id]);

  useEffect(() => {
    if (allTags) {
      const tags = _clonedeep(allTags);
      tags.map((tag, index: number) => {
        tag.id = `filter_${index + 1}`;
      });
      setTagFilters(tags);
    } else {
      setTagFilters(filterData);
    }
  }, [tagsFetching]);

  const {
    data: favorites = [],
    isFetching: isFavFetching,
    refetch,
  } = useFavorites(authInfo.userId, authInfo.type);

  const [favoriteItems, setFavoriteItems] = useState([]);

  useEffect(() => {
    if(authInfo.type !== CONSTANT.GUEST_USER) refetch();
  }, []);

  useEffect(() => {
    if (favorites.length > 0) setFavoriteItems(favorites);
  }, [favorites]);

  const scrollRef = useCallback((node) => {
    if (node !== null) handleScrollToActiveLink(node);
  }, []);

  const handleScrollToActiveLink = (node: any) => {
    let navElement: HTMLElement = document.getElementById(selected_category);
    if (navElement && node) {
      const leftCordinate = navElement.getClientRects()[0].left;
      node.scrollLeft(leftCordinate - 100);
    }
  };

  let { mutateAsync: removeFavorite } = useRemoveFavorite();
  let { mutateAsync: addFavorite } = useAddFavorites();

  const [accountStatusModal, setAccountStatusModal] = useState<IAccountStatus>({
    code: null,
    buttonText: null,
    isError: null,
    header: null,
    text: null,
    email: null,
    show: false,
  });
  const { isVerifyingEmailLink } = useVerifyAccount(
    accountStatusModal,
    setAccountStatusModal
  );
  const closeAccountStatusModal = () => {
    setAccountStatusModal({
      code: null,
      buttonText: null,
      isError: null,
      header: null,
      text: null,
      email: null,
      show: false,
    });
  };
  const updateAccountStatusModal = (
    header: string,
    text: string,
    code: number,
    buttonText: string,
    email: string,
    isError: boolean
  ) => {
    setAccountStatusModal({
      code,
      buttonText,
      isError,
      header,
      text,
      email,
      show: true,
    });
  };

  useEffect(() => {
    if (redeemedOrder?.rewardedOrder?.isCategory) {
      setRouterState(redeemedOrder?.rewardedOrder);
    } else {
      if (location.state) {
        setRouterState(location.state);
      }
    }
  }, [location.pathname, location.state]);

  useEffect(() => {
    if (!categoryMenuVisbility) setCategoryMenuVisbility(true);
    if (menus.length > 0) {
      if (
        selected_category &&
        menus.some((menu) => menu.name === selected_category)
      ) {
        setKey(selected_category);
        setTitleTag(selected_category)
      } else {
        if (menus.length >= 1) { 
          setKey(menus[1].name);
          setTitleTag(menus[1].name)
        }
        else {
          setKey(menus[0].name);
          setTitleTag(menus[0].name)
        }
      }
    }
    setShowScrollBar(true);
  }, [menus, selected_category]);

  useEffect(() => {
    if (key) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      setSearchShow(false);
      clearSearch();
      let redirectToMenu =
        !dbId ||
        (key !== CONSTANT.TRY_2_COMBO_CAPITALIZE &&
          key !== CONSTANT.KIDS_COMBO_CAPITALIZE);
      if (redirectToMenu)
        history.push({
          pathname: `${CONSTANT.ROUTE_MENU}/${key}`,
          search: search,
          state: state,
        });
    }
  }, [key]);

  const handleScroll = () => {
    window.scrollY > 1
      ? setStickyClass("add-sticky")
      : setStickyClass("remove-sticky");
  };

  useEffect(() => {
    if (redeemedOrder?.rewardedOrder?.isCategory) {
      setRouterState(redeemedOrder?.rewardedOrder);
    } else {
      setRouterState(location.state);
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      dispatch(resetRedeemedOrderContex());
    };
  }, []);

  useEffect(() => {
    var nav = document.getElementsByClassName("Scrollbar_view")[0];
    if (!nav) return;
    var navWidth = window.getComputedStyle(nav, null).getPropertyValue("width");
    document.documentElement.style.setProperty(
      "--get-nav-width",
      `${navWidth}`
    );
  }, [menus]);

  const filterHandler = () => {
    setfilterShow(true);
    setactiveFilters(true);
    setSearchShow(false);
  };
  const filterCloseHandler = () => {
    setfilterShow(false);
    setactiveFilters(false);
    if (isSearching) getSearchItems();
  };

  const serachShow = () => {
    searchTextRef.current = searchText;
    setSearchShow(true);
    setactiveFilters(true);
    setfilterShow(false);
  };
  const serachHide = () => {
    setSearchShow(false);
    setactiveFilters(false);
    if (!searchText && isFilterApplied) return;
    getSearchItems();
    setIsSearching(true);
  };

  const clearSearch = () => {
    searchTextRef.current = "";
    setSearchText("");
    setIsSearching(false);
    setItems([]);
  };
  const MenuLinksHandler = (menu) => {
    if (redeemedOrder?.rewardedOrder?.name) {
      if (
        redeemedOrder?.rewardedOrder?.name.toLowerCase() !==
        menu.name.toLowerCase()
      ) {
        dispatch(resetRedeemedOrderContex());
        setRouterState({});
      }
    }
    if (isSearching) {
      clearSearch();
    }
    brazeLogCustomEventViewPage(`${menu?.name} Menu`, isItMobile);
    setactiveFilters(false);
    const resetFilters = getResetFilters(tagFilters);
    setTagFilters(resetFilters);
    setIsFilterApplied(false);
    setIsSearching(false);
    setfilterShow(false);
    history.replace(`${CONSTANT.ROUTE_MENU}/${menu.name}`, {
      showCustomization: false,
    });
    setTitleTag(menu.name);
  };

  const selectedFilters = tagFilters.filter((tagFilter) => tagFilter.selected);

  const getSearchItems = () => {
    const searchByValue = searchText?.trim();
    if (searchByValue?.length <= 0) return;
    let searchArray = [];
    for (let i = 0; i < menus.length; i++) {
      let menuItemsToSearchFrom = menus[i].items;
      if (isFilterApplied)
        if (location.pathname.includes(menus[i].name)) {
          menuItemsToSearchFrom = getFilteredItems(
            menus[i].items,
            selectedFilters
          );
        } else menuItemsToSearchFrom = [];
      menuItemsToSearchFrom.forEach((item) => {
        if (
          (item.name
            .toLocaleLowerCase()
            .includes(searchByValue.toLocaleLowerCase()) ||
            item.description
              .toLocaleLowerCase()
              .includes(searchByValue.toLocaleLowerCase())) &&
          !(menus[i].is_try_2_combo || menus[i].is_kids_combo)
        ) {
          searchArray.push(item);
        }
      });
    }
    setItems(uniqBy(searchArray, "id"));
  };
  // useEffect(()=>{

  // },[isSearching])

  const removeFavoriteItem = (favoriteItemId: any, item: any) => {
    const userId = authInfo.userId;
    removeFavorite(
      { itemId: favoriteItemId, userId },
      {
        onError: (error, variables, context) => {
          setFavoriteItems([...favoriteItems, { ...item, item_id: item.id }]);
        },
      }
    );
  };

  const addFavoriteItem = (item: any) => {
    addFavorite(
      { ...item, customer_id: authInfo.userId },
      {
        onError: (error, variables, context) => {
          const favoritesCopy = [...favoriteItems];
          const favoriteItemId = favoriteItems.findIndex(
            (fav) => fav.item_id === item.id
          );
          favoritesCopy.splice(favoriteItemId, 1);
          setFavoriteItems(favoritesCopy);
        },
      }
    );
  };

  useEffect(() => {
    if (authInfo && authInfo?.userId && authInfo?.access_token) {
      refetchGetCustomerPlacedOrders();
    }
  }, [authInfo?.userId]);

  const debouncedAddFavourite = useCallback(
    _debounce(addFavoriteItem, 500),
    []
  );
  const debouncedRemoveFavourite = useCallback(
    _debounce(removeFavoriteItem, 500),
    []
  );

  const favoriteButtonHandler = (
    e: React.MouseEvent<HTMLButtonElement>,
    item
  ) => {
    const favoriteItemId = favoriteItems.findIndex(
      (fav) => fav.item_id === item.id
    );
    const favoritesCopy = [...favoriteItems];
    const itemId = item.id;
    if (favoriteItemId === -1) {
      favoritesCopy.push({ ...item, item_id: item.id });
      setFavoriteItems(favoritesCopy);
      debouncedAddFavourite(item);
    } else {
      favoritesCopy.splice(favoriteItemId, 1);
      setFavoriteItems(favoritesCopy);
      debouncedRemoveFavourite(itemId, item);
    }
    e.stopPropagation();
  };
  const isCheckTrackBar = useAppSelector((state) => state.checkout?.trackOrder);

  const showLoyaltyBanner =
    process.env.REACT_APP_SHOW_LOYALTY_BANNER === "true" ? true : false;

  return isFetching || isFavFetching || isVerifyingEmailLink ? (
    <Spinner lightBg={true}></Spinner>
  ) : (
    <React.Fragment>
      {showKioskResponseModal()}
      {QRScannerModal()}
      <div
        className={`${
          styleClasses.menu_categories_wrapper
        } menu_categories_wrapper position-relative menu-page ${
          showScrollBar && stickyClass
        } ${activeFilters ? " search-active" : ""}   ${
          isCheckTrackBar ? "track-here" : ""
        } ${onScrollNavHide ? "add-sticky" : "remove-sticky"} `}
      >
        {SearchShow && (
          <ItemSearch
            targetState={searchText}
            setTargetState={setSearchText}
            searchHandle={serachHide}
            clearSearch={clearSearch}
            searchtrack={`${
              isCheckTrackBar ? styleClasses.track_here_search : styleClasses.no_track_here_search
            }`}
          />
        )}
        <Container fluid className={`px-lg-5 ${isItMobile && 'cz-px-10'}`}>
          <div
            className={`${styleClasses.menu_filters_wrap} menu-parent ${
              isCheckTrackBar ? null : "no-track-heading"
            }`}
          >
            {showScrollBar && (
              <div className="position-relative">
                <h1 className="menu_cate_title h-18 text-start mb-0 pt-1">
                  Menu Categories
                </h1>
                <div
                  className={`${styleClasses.filters_btns} filters_btns d-md-none`}
                >
                  <button
                    type="button"
                    className={`${styleClasses.search_btn} btn btn-custom f-s0`}
                    onClick={serachShow}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className={`${
                      styleClasses.filter_btn
                    } btn btn-custom f-s0 ${
                      filterShow ? styleClasses.active : " "
                    }`}
                    onClick={filterHandler}
                  >
                    filter
                  </button>
                  <span className="font-weight-bold">
                    {selectedFilters.length || ""}
                  </span>
                </div>
              </div>
            )}
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey="first"
              activeKey={key}
              onSelect={(k) => setKey(k)}
            >
              {showScrollBar && (
                <div className="nav nav-pills">
                  <div
                    className={`${styleClasses.menu_tabs} menu_tabs_wrap  blue`}
                  >
                    <Scrollbars
                      className={styleClasses.menu_items_scrollbar}
                      ref={scrollRef}
                      renderThumbHorizontal={(props) => (
                        <div
                          {...props}
                          className={styleClasses.Scrollbar_thumb}
                        />
                      )}
                      renderView={(props) => (
                        <div
                          {...props}
                          className={`${styleClasses.Scrollbar_view} Scrollbar_view`}
                        />
                      )}
                    >
                      {menus.map((menu, i: number) => (
                        <>
                          <Helmet>
                            <script>
                              {`
                                  document.getElementById("${
                                    menu.name
                                  }").addEventListener("click", function () {
                                    gtag("event", "view_item_list", {
                                        user_id: ${authUserId || null},
                                        item_list_id: "${menu?.id}",
                                        item_list_name: "${menu?.name}",
                                        items: ${JSON.stringify(
                                          getStructuredItemList(
                                            menu?.items as any,
                                            locationInfo?.selectedStore?.id
                                          )
                                        )}
                                    });
                                  }); 
                                  `}
                            </script>
                          </Helmet>
                          <Nav.Item
                            id={menu.name}
                            key={i}
                            className={styleClasses.nav_item}
                          >
                            <Nav.Link
                              eventKey={menu.name}
                              onClick={() => MenuLinksHandler(menu)}
                              className={`${
                                selected_category === menu.name ? "active" : ""
                              }`}
                            >
                              {menu.name}
                            </Nav.Link>
                          </Nav.Item>
                        </>
                      ))}
                      <div
                        className={`${styleClasses.filters_btns} d-none d-md-flex align-items-md-center`}
                      >
                        <button
                          type="button"
                          className={`${styleClasses.search_btn} btn btn-custom f-s0`}
                          onClick={serachShow}
                        >
                          Search
                        </button>
                        <button
                          type="button"
                          className={`${
                            styleClasses.filter_btn
                          } btn btn-custom f-s0 ${
                            filterShow ? styleClasses.active : " "
                          }`}
                          onClick={filterHandler}
                        >
                          Filter
                        </button>
                        <span className="font-weight-bold ps-1">
                          {selectedFilters.length || ""}
                        </span>
                      </div>
                    </Scrollbars>
                  </div>
                  {/* Filters */}
                  <MenuFilters
                    filterShow={filterShow}
                    filterCloseHandler={filterCloseHandler}
                    filters={tagFilters}
                    setFilters={setTagFilters}
                    allTags={allTags}
                    setIsFilterApplied={setIsFilterApplied}
                  />
                </div>
              )}
              <Tab.Content>
                {menus.map((menu: any, i: number) => {
                  const filteredItems = isSearching
                    ? items
                    : getFilteredItems(menu.items, selectedFilters);
                  // if(isFetchingCombo) return <Spinner lightBg={true}></Spinner>
                  return (
                    <React.Fragment key={menu.id}>
                      <Helmet><title> {titleTag} | Cafe Zupas </title></Helmet>
                      <Tab.Pane
                        key={i}
                        eventKey={menu.name}
                        className={`menus_pane tab_pane ${
                          !categoryMenuVisbility
                            ? "no-menu-category-bar"
                            : "with-menu-category"
                        } ${isCheckTrackBar && 'menus_pane_with_track_bar'}`}
                      >
                        {!isSearching && menu.is_try_2_combo ? (
                          key === menu.name ? (
                            <Try2Combo
                              item_id={menu.items[0].id.toString()}
                              name={menu.name}
                              favorites={favoriteItems}
                              favoriteButtonHandler={favoriteButtonHandler}
                              location_id={location_id?.toString()}
                              category_id={menu.id}
                              hideScroll={(state) => {
                                setShowScrollBar(state);
                              }}
                              showCustomization={showCustomization}
                              dbId={dbId}
                              itemFromApi={itemFromApi}
                              selectedFilters={selectedFilters}
                              isFetching={isFetchingCombo}
                              autoScrollDivRef={autoScrollDivRef}
                              setCategoryMenuVisibility={
                                setCategoryMenuVisbility
                              }
                              setItemDetailss={setItemDetails}
                              routeStates={routerState}
                            />
                          ) : null
                        ) : !isSearching && menu.is_kids_combo ? (
                          key === menu.name ? (
                            <KidsCombo
                              item_id={menu.items[0].id.toString()}
                              name={menu.name}
                              location_id={location_id?.toString()}
                              category_id={menu?.id}
                              favorites={favoriteItems}
                              favoriteButtonHandler={favoriteButtonHandler}
                              kidsComboPropData={menu?.items[0]}
                              showCustomization={showCustomization}
                              dbId={dbId}
                              itemFromApi={kidsComboData}
                              isFetching={kidsComboLoading}
                              refetch={refetchKidsCombo}
                              routeStates={routerState}
                            />
                          ) : null
                        ) : (
                          <>
                            {filteredItems.length !== 0 &&
                              !isSearching &&
                              !isFilterApplied && (
                                <div
                                  className={`${styleClasses.menu_category_title_wrap} text-start pt-0 pt-md-3`}
                                >
                                  <h5 className="h-30">{menu.name}</h5>
                                  <p className="p-18 mb-4">
                                    {menu.description
                                      ? Parser(menu.description)
                                      : ""}{" "}
                                    {/* (
                                  {menu.calories && menu.calories !== null
                                    ? menu.calories + " cal"
                                    : " "}
                                  ) */}
                                  </p>
                                </div>
                              )}
                            {(isSearching || isFilterApplied) && (
                              <div
                                className={`${styleClasses.menu_category_title_wrap} text-start pt-0 pt-md-3`}
                              >
                                <h5 className="h-30">Search Results</h5>
                              </div>
                            )}
                            <ItemGrid
                              items={filteredItems}
                              addToOrder={addToOrder}
                              searchText={
                                SearchShow ? searchTextRef.current : searchText
                              }
                              location_id={location_id}
                              category_id={menu.id}
                              favorites={favoriteItems}
                              favoriteButtonHandler={favoriteButtonHandler}
                              name={menu.name}
                              userId={authInfo.userId}
                              routeState={routerState}
                              selected_category={selected_category}
                              categoryMenu={menus}
                            />
                          </>
                        )}
                      </Tab.Pane>
                    </React.Fragment>
                  );
                })}
              </Tab.Content>
            </Tab.Container>
          </div>
        </Container>
        <div className="pt-md-5">
          <NewFooter footer_img_controller="d-none"></NewFooter>
        </div>
        {authInfo.type !== CONSTANT.GUEST_USER ? (
          <UserSelections
            isRewardCatalogLoading={isLoading}
            isRewardCatalogError={isError}
            isRewardCatalogSuccess={isSuccess}
            rewardCatalogError={error}
            rewardCatalogData={data}
          />
        ) : null}
        <AccountStatusModal
          accountStatusModal={accountStatusModal}
          updateAccountStatusModal={updateAccountStatusModal}
          closeModal={closeAccountStatusModal}
        />
      </div>
    </React.Fragment>
  );
};

export default withRouter(MenuContainer);

const useKioskLoginFlow = () => {
  const history: any = useHistory();
  const { removeKioskLoginSession } = useKioskLogin();

  const [showResponseModal, setResponseModal] = useState(false);
  const [showQRCodeModal, setShowQRCodeModal] = useState(false);
  const isKioskLoginFlow = history.location.state?.isKioskLoginFlow;
  const status = history.location.state?.status;
  const message = history.location.state?.message;

  useEffect(() => {
    if (isKioskLoginFlow) {
      setResponseModal(true);
    }
  }, [isKioskLoginFlow]);

  const removeKioskHistoryState = () => {
    const newStates = history.location.state;
    delete newStates["isKioskLoginFlow"];
    delete newStates["status"];
    delete newStates["message"];
    history.replace({
      ...history.location,
      state: newStates,
    });
  };

  const handleButtonClick = () => {
    setResponseModal(false);
    if (!status) {
      setShowQRCodeModal(true);
    } else {
      removeKioskHistoryState();
      removeKioskLoginSession();
    }
  };

  const handleNoThanksButtonClick = () => {
    setResponseModal(false);
    removeKioskHistoryState();
    removeKioskLoginSession();
  };

  const closeQRScannerModal = () => {
    setShowQRCodeModal(false);
  };

  const openResponseModal = () => {
    setResponseModal(true);
  };

  const showKioskResponseModal = () => {
    return (
      <Modal
        show={showResponseModal}
        centered
        className="theme-modal-style app_container_wrap border-radius-15 px-5 order_type_modal"
      >
        <Modal.Header className="x-4 justify-content-center"></Modal.Header>
        <Modal.Body className="py-4">
          <h5 className="f-s18 font-Cls text-center fw-normal pb-5 text-capitalize">
            {message}
          </h5>
          <div
            className={`d-flex gap-md-3 flex-column flex-md-row align-items-center ${styleClasses.kioskModalloginSuccessbtn}`}
          >
            <button
              type="button"
              className="btn btn-large py-2 lh-lg f-s16 w-100 mb-3"
              onClick={handleButtonClick}
            >
              {status ? "Ok" : "Scan The QR Code Again"}
            </button>
            {!status && (
              <button
                type="button"
                className="btn btn-large py-2 lh-lg f-s16 w-100 mb-3 outline"
                onClick={handleNoThanksButtonClick}
              >
                {"No Thanks"}
              </button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  const QRScannerModal = () => {
    return (
      <QRScanner
        showModal={showQRCodeModal}
        closeModal={closeQRScannerModal}
        openResponseModal={openResponseModal}
        history={history}
        removeKioskHistoryState={removeKioskHistoryState}
      />
    );
  };

  return { showKioskResponseModal, QRScannerModal };
};
